import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import noop from 'lodash/noop';

import style from './Alert.module.scss';

export default function Alert(props) {
  const { className, warning, error, children, ...otherProps } = props;

  return (
    <div
      className={classnames(
        style.alert,
        {
          [style.error]: error,
          [style.warning]: warning,
        },
        className,
      )}
      {...otherProps}
    >
      {children}
    </div>
  );
}

Alert.propTypes = {
  /**
   * children to put inside the Alert
   */
  children: PropTypes.node,
  /**
   * html class
   */
  className: PropTypes.string,
  /**
   * specifies whether this is an error alert
   */
  error: PropTypes.bool,
  /**
   * specifies whether this is an warning alert
   */
  warning: PropTypes.bool,
};

Alert.defaultProps = {
  children: null,
  className: '',
  error: false,
  warning: false,
  onDismiss: noop,
};

Alert.displayName = 'Alert';
